import accuracyPlot from "../../../../content/posts/blogs/2021/qscores/accuracy.jsx";
import qscorePlot from "../../../../content/posts/blogs/2021/qscores/qscore.jsx";
import jeffreysPlot from "../../../../content/posts/blogs/2021/qscores/qscore-pseudo.jsx";
import * as React from 'react';
export default {
  accuracyPlot,
  qscorePlot,
  jeffreysPlot,
  React
};